import { computed } from 'vue';
import { useConsentStore } from '@/stores/consentStore';

// Lightweight composable that centralizes analytics usage and consent checks
export function useAnalytics() {
  const consentStore = useConsentStore();

  const isEnabled = computed(() => consentStore.canUseAnalytics);

  // Track a generic event via seoAnalytics or firebase analytics if available
  const trackEvent = async (eventName: string, params?: Record<string, any>) => {
    if (!isEnabled.value) return;

    try {
      // Prefer seoAnalytics for high-level events (gtag) if available
      const { seoAnalytics } = await import('@/utils/seoAnalytics');
      seoAnalytics.trackEngagement(eventName, params?.category || 'App', params?.label || undefined, params?.value);
    } catch (e) {
      // Fallback to firebase analytics service if present
      try {
        const analytics = await import('@/firebase/services/analyticsService');
        if (analytics && typeof analytics.logEventSafe === 'function') {
          analytics.logEventSafe(eventName, params || {});
        }
      } catch (err) {
        // swallow; analytics is best-effort
      }
    }
  };

  return {
    isEnabled,
    trackEvent
  };
}
